// extracted by mini-css-extract-plugin
export default {"icon":"GeneratingLabel_icon__UFimI","load":"GeneratingLabel_load__zXtAw"};